import React, { useEffect, useState, useRef } from "react";
import GeneratePayslipComponent from "./Component/GeneratePayslipComponent";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import moment from "moment";
import { API_URL } from "../../../../constants";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import printJS from "print-js";
import { useLocation, useNavigate } from "react-router-dom";

const GeneratePayrollAdvice = () => {
  const dispatch = useDispatch();
  const location = useLocation()
  const passedState = location.state;

  useEffect(() => {
    dispatch(updateNavbarHeading(passedState ? passedState?.text : "Generate Payroll Advice"));
  }, []);


  const navigate = useNavigate()

  const [branchOption, setBranchOption] = useState([]);
  const [monthsOption, setMonthsOption] = useState([]);
  const [employeeOption, setEmployeeOption] = useState([]);
  const [bankOption, setBankOption] = useState([]);
  const [accountOption, setAccountOption] = useState([]);


  useEffect(() => {
    fetchGetApi();
  }, []);
  const fetchGetApi = async () => {
    try {
      let response;

      response = await GetServiceCaller(
        `${API_URL}rujul/generate-payroll-advisory`
      );

      if (response?.status === 200) {
        const cleanedData = response?.data?.data;

        const branchOpt = cleanedData?.branch?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));

        setBranchOption(branchOpt);

        const accOpt = cleanedData?.accountmaster?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));

        setAccountOption(accOpt);

        const empOpt = cleanedData?.employee?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));

        setEmployeeOption(empOpt);
        const bankOpt = cleanedData?.bank?.map((ele, index) => ({
          value: ele?.ID,
          label: ele?.Name,
        }));

        setBankOption(bankOpt);
        const monOpt = cleanedData?.months?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));

        setMonthsOption(monOpt);
      }
    } catch (error) {
      console.error("Fetching Data Error ", error);
    }
  };

  const columns = {
    Branch: { text: "Branch", align: "start", visible: true },
    Code: {
      text: "EMP ID",
      align: "start",
      width: "60px",
      visible: true,
      type: "Link",
    },
    Name: { text: "Employee", align: "start", visible: true },
    PersonalEmail: { text: "Personal Email", align: "end", visible: true },
    MobileNumber: { text: "Mobile Number", align: "end", visible: true },
    Bank: { text: "Bank", align: "start", visible: true },
    BankAccountNo: { text: "Account No.", align: "center", visible: true },
    BankIFSCCode: { text: "IFSC Code", align: "center", visible: true },
    Amount: { text: "Total Amount", align: "end", visible: true }
    // OnAttendance: { text: "on Attendance", align: "center", visible: true },
  };


  const initialFilterData = [
    { label: "Branch", value: { value: 2, label: "NSS-Main" } },
  ]
  const [filterFormData, setFilterData] = useState(initialFilterData);

  const handleChange = (e, name) => {
    // Convert the date to "YYYY-MM" format if it's a valid date
    const formattedValue = moment(e, "DD-MMM-YYYY").isValid()
      ? moment(e, "DD-MMM-YYYY").format("YYYY-MM")
      : e;

    console.log("tests the server", formattedValue, name);

    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? {
              ...item,
              value: formattedValue !== undefined ? formattedValue : e,
            }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: formattedValue !== undefined ? formattedValue : e, // Assuming e is an event object
          },
        ];
      }
    });
  };

  const formDatas = [
    { name: "Branch", type: "Select", options: [...branchOption] },
    { name: "Month", type: "Select", options: [...monthsOption] },
    { name: "Employee", type: "Select", options: [...employeeOption] },
    { name: "Account", type: "Select", options: [...accountOption] },
    { name: "Bank", type: "Select", options: [...bankOption] },
  ];

  const [searchTerm, setSearchTerm] = useState("");

  const [generatePayslipData, setGeneratePayslipData] = useState([]);
  const [apiStatus, SetApiStatus] = useState('');
  const handleGetData = async () => {
    SetApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}rujul/generate-payroll-advisory-data?p_MonthID=${filterFormData.find((o) => o.label === "Month")
          ? filterFormData.find((o) => o.label === "Month").value.value
          : 0
        }&p_EmployeeID=${filterFormData.find((o) => o.label === "Employee")
          ? filterFormData.find((o) => o.label === "Employee").value.value
          : 0
        }&p_BankID=${filterFormData.find((o) => o.label === "Bank")
          ? filterFormData.find((o) => o.label === "Bank").value.value
          : 0
        }
 `
      );

      SetApiStatus(response?.status);
      const cleanedData = response?.data?.data;
      if (response?.status === 200) {

        setGeneratePayslipData(cleanedData);
      }
    } catch (error) { }
  };

  const componentRef = useRef(null); // Create a ref for the prinTable section

  const handlePrint = () => {
    printJS({
      printable: "printSection", // Corrected property name
      type: "html",
      css: ["index.css"], // External CSS file
      style: `
                    @page { size: A4; margin: 0.7mm; } /* Define Page Size and Margin */
        
                    table {
                        border-collapse: collapse !important;
                        width: 100% !important;
                        table-layout: fixed !important; /* Ensures equal column distribution */
                    }
        
                    table, th, td {
                        border: 1px solid black !important;
                    }
        
                    th, td {
                        padding: 8px !important;
                        text-align: left !important;
                        word-wrap: break-word !important; /* Prevents text overflow */
                    }
        
                    /* Override Bootstrap classes for printing */
                    [class*="col-"] { width: auto !important; } /* Reset Bootstrap grid */
                    .col-md-3 { width: 25% !important; }  
                    .col-md-4 { width: 30% !important; }
                    .col-md-6 { width: 50% !important; }
                    .col-md-8 { width: 70% !important; }
                    .col-md-12 { width: 100% !important; }
        
                    /* Ensure background colors print */
                    .tbl-heading-tx {
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                        background-color: #d1ecf1 !important;
                    }
        
                    /* Hide buttons and remarks in print */
                    .btn, .remark-container {
                        display: none !important;
                    }
                `,
      scanStyles: false, // Prevents conflicts with Bootstrap styles
    });
  };

  const handleReset = async () => {
    setFilterData(initialFilterData)


    SetApiStatus(undefined)

    try {
      const response = await GetServiceCaller(
        `${API_URL}rujul/generate-payroll-advisory-data?p_MonthID=&p_EmployeeID=&p_BankID=
 `
      );

      SetApiStatus(response?.status);
      const cleanedData = response?.data?.data;
      if (response?.status === 200) {

        setGeneratePayslipData(cleanedData);
      }
    } catch (error) {

      console.error("Fetching Error ", error);

    }

  }

  const hanldeLinkColumn = (columnName, item) => {
    navigate(`/employee-profile/${item.ContactID}`);

  }

  // <-- Removed extra } here

  return (
    <div className="container-fluid" id="skill_section">
      <div className=" rounded bg-white" id="skill-table-area">
        <div className="row mt-2">
          <GeneratePayslipComponent
            data={generatePayslipData}
            columns={columns}
            refPrint={componentRef}
            printId={"printSection"}
            itemsPerPage={10}
            searchTerm={searchTerm}
            handleReset={handleReset}

            formDatas={formDatas}
            setSearchTerm={setSearchTerm}
            filterFormData={filterFormData}
            handleGetData={handleGetData}
            isSrNoRequired={false}
            isFilterRequired={true}
            isApiStatus={apiStatus}
            isRequiredStatus={true}
            showIcon1={false}
            hanldeLinkColumn={hanldeLinkColumn}
            showIcon2={false}
            isActionRequired={false}
            isPrintBtnRequired={true}
            showIcon3={false}
            handleChange={handleChange}
            showIcon4={false}
            showIcon5={false}
            // formattedKeys={totalCount}
            // totals={totalAmount}
            // handleIcon1={handleEdit}
            // handleIcon2={handleDeleteModal}
            handleAddNew={handlePrint}
            add
            more
            function
            icons={{
              Icon1: <i class="bi bi-pencil-square icons"></i>,
              Icon1Text: " Edit",
              Icon2: <i class="bi bi-trash-fill icons"></i>,
              Icon2Text: "Delete",
              Icon3: <i class="bi bi-eye-fill icons"></i>,
              Icon4: <i class="bi bi-plus-square icons"></i>,
              Icon4Text: " Add Sub-Contractor",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default GeneratePayrollAdvice;
